import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Loader from "../../Utility/loading";
import backArrowIcon from "../../assets/new icons/extraction review/back arrow.svg";
import rightArrowIcon from "../../assets/new icons/extraction review/right arrow.svg";
import "../Constants/config.css";

import { countries, fontFamily, useSharedValue } from "../Constants/constants";
import deleteIcon from "../../assets/new icons/trash.svg";
import refreshIcon from "../../assets/new icons/extraction review/refresh.svg";
import {
  DownloadExcelFile,
  DownloadOriginalFile,
  ExcelIcon,
  formatDate,
} from "../../Utility/utility";
import SecureDocumentViewer from "../WorkLoade_File_Import/SecureDocumentViewer";
import { getMatchRowStyle } from "../../services/MatchingEntityService";
import FormTablesDisplay from "./FormTablesDisplay";
import { validateField } from "../Constants/validationRules";
import { countriesWithStates, isValidStateForCountry } from "../Constants/countrisStatesList";
import {
  allSheetNames,
  chapter4StatusOptions,
  entityClassificationOptions,
  entityTypeOptions,
  formsTypeList,
  incomeCodesDropDownList,
  statesList,
} from "../list";
import { getFormFieldOrder, sortByFieldOrder } from "../../Forms/formFieldOrder";
import DataValidationLegend from "./legend";

const hybridStatusOptions = ["Hybrid", "Reverse Hybrid", "Not Applicable"];
const trinaryOptions = ["TRUE", "FALSE", "UNKNOWN"];
const booleanOptions = ["TRUE", "FALSE"];
const usTinClassificationOptions = ["EIN", "SSN", "ITIN", "Other"];
const taxpayerTypeOptions = [
  "ATIN",
  "EIN",
  "ITIN",
  "PTIN",
  "QIEIN",
  "SSN/ITIN",
  "WPEIN",
  "WP-EIN",
  "WTEIN",
  "WT-EIN",
];
const recipientCodeOptions = Array.from({ length: 22 }, (_, index) =>
  String(index + 1).padStart(2, "0")
);
const legalStatusOptions = [
  "Corporation",
  "Foundation",
  "General Partnership",
  "Limited Liability Company",
  "Limited partnership",
  "Private Limited Company",
  "Public Limited Company",
  "Sole Trader",
  "Trust",
  "Unknown",
];
const entityActivationStatusOptions = ["Active", "Deceased", "Suspended"];
const riskStatusOptions = ["Medium", "Not Applicable", "High", "Low"];
const incomeCodesComparisonOptions = [
  "Government",
  "Tax exempt pension trust or pension fund",
  "Other tax exempt organization",
  "Publicly traded corporation",
  "Publicity traded corporation",
  "Subsidiary of a publicly traded corporation",
  "Company that meets the ownership and base erosion test",
  "Company that meets the derivative benefits test",
  "Company with an item of income that meets active trade or business test",
  "Favorable discretionary determination by the U.S. competent authority received",
  "No LOB article in treaty",
  "Other",
];
const documentaryEvidenceTypeOptions = [
  " ",
  "Passport",
  "Driving License",
  "National ID Card",
  "National ID Card of A Member",
  "State of the EU",
  "Armed Forces Card",
  "Birth Certificate",
  "Partnership Agreement",
  "Certificate of Incorporation",
  "Trust Deed or Certified Extracts",
  "Public Register Extracts",
  "Limitations of Benefits Statement",
  "Signature",
  "Other",
];
const balanceEntityTypeOptions = ["Individual", "Entity"];
const fatcaReportingBalanceOptions = [
  "<$50,000",
  ">$50,000",
  "<$250,000",
  ">$250,000",
  "Info Not Available",
];
const formStatusOptions = [
  "Valid",
  "Active",
  "Under Review",
  "Other",
  "Invalid",
  "Orphan",
  "Expired",
  "Rejected",
  "Superseded",
];
const incomeType1099Options = [
  "Rents",
  "Royalties",
  "Other Income",
  "Federal Income Tax Withheld",
  "Fishing Boat Proceeds",
  "Medical and Health Care Payments",
  "Nonemployee Payments",
  "Substitute Payments in Lieu",
  "Crop Insurance Proceeds",
  "Excess Golden Parachute Payments",
  "Gross Proceeds to an Attorney",
  "Section 409A Deferrals",
  "Section 409A Income",
  "State Income",
];
const incomeTypeDefaultOptions = [
  "Attorney Fees",
  "Crop insurance proceeds",
  "Dependent Personal Services",
  "Dividends",
  "Independent Personal Services",
  "Interest",
  "Medical and Health Care Payments",
  "Nonemployee Compensation",
  "Other",
  "Prizes and Awards",
  "Rents",
  "Retirement Plan Distribution",
  "Royalties",
  "Third-Party Payments Processors (including credit card payment processors)",
];
const exemptionCodeOptions = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "99",
];
const propertyTypeOptions = [
  "Office",
  "Immovable Property",
  "Hotel room",
  "Personal Service",
  "Sale of Goods",
  "Transportation Rental",
  "Bed and Breakfast room",
  "House",
  "Apartment",
  "Mobile home",
  "Campground",
  "Boat",
  "Parking space",
  "Other",
];
const entityTypesForExpOptions = [
  "Foreign Central Bank of Issue",
  "Foreign Government",
  "Foreign Private Foundation",
  "Foreign Tax-Exempt Organization",
  "Government of a U.S. territory",
  "International Organization",
  "Legal person - Control by ownership",
  "Legal person – Control by ownership",
  "Legal person - Control by other means",
  "Legal person – Control by other means",
  "Legal person - Senior managing official",
  "Legal person – Senior managing official",
  "Trust - Settlor",
  "Trust – Settlor",
  "Trust - Trustee",
  "Trust – Trustee",
  "Trust - Protector",
  "Trust – Protector",
  "Trust - Beneficiary",
  "Trust – Beneficiary",
  "Trust - Other",
  "Trust – Other",
  "Legal arrangement (non-trust) - Settlor equivalent",
  "Legal arrangement (non-trust) – Settlor equivalent",
  "Legal arrangement (non-trust) - Trustee equivalent",
  "Legal arrangement (non-trust) – Trustee equivalent",
  "Legal arrangement (non-trust) - Protector equivalent",
  "Legal arrangement (non-trust) – Protector equivalent",
  "Legal arrangement (non-trust) - Beneficiary equivalent",
  "Legal arrangement (non-trust) – Beneficiary equivalent",
  "Legal arrangement (non-trust) - Other equivalent",
  "Legal arrangement (non-trust) – Other equivalent",
];
const ukCDOTStatusOptions = [
  "A broker or dealer in securities, commodities, or derivative financial instruments that is registered as such under the laws of the UK",
  "A corporation the stock of which is regularly traded on an established securities market or a corporation that is a member of the same affiliated group as such a corporation",
  "A depository institution",
  "A Non-Reportable UK Entity",
  "Active Non-Financial Foreign Entity",
  "Exempt Beneficial Owner",
  "Financial Institution",
  "None",
  "Passive Non-Financial Foreign Entity",
];
const crsStatusOptions = [
  "A broker or dealer in securities, commodities, or derivative financial instruments that is registered as such under the laws of the UK",
  "A depository institution",
  "A Non-Reportable UK Entity",
  "A professionally managed Investment Entity outside of a CRS Participating Jurisdiction",
  "Active NFE by reason of income and assets",
  "Active NFE- Central Bank",
  "Active NFE- Governmental Entity",
  "Active NFE- International Organization",
  "Active Non-Financial Entity",
  "Active Non-Financial Entity - a corporation the stock of which is regularly traded on an established securities market or a corporation which is a related entity of such a corporation",
  "Active Non-Financial Entity - a Government Entity or International Organization or Central Bank",
  "Active Non-Financial Entity which is regularly traded on an established securities market or affiliated thereto, a Governmental Entity or an International Organisation",
  "An Investment Entity located in a Non-Participating Jurisdiction and managed by another Financial Institution",
  "Central Bank",
  "Davids New Reason",
  "Financial Institution",
  "Financial Institution - Depository Institution, Custodial Institution or Specified Insurance Company",
  "Holding NFE that is a member of a nonfinancial group",
  "NFE that is liquidating or emerging from bankruptcy",
  "Non-profit NFE",
  "Non-Reporting Financial Institution under CRS - Broad Participation Retirement Fund",
  "Non-Reporting Financial Institution under CRS - Central Bank",
  "Non-Reporting Financial Institution under CRS - Exempt Collective Investment Vehicle",
  "Non-Reporting Financial Institution under CRS - Governmental Entity",
  "Non-Reporting Financial Institution under CRS - International Organization",
  "Non-Reporting Financial Institution under CRS - Narrow Participation Retirement Fund",
  "Non-Reporting Financial Institution under CRS - Other Entity defined under the domestic law as low risk of being used to evade tax",
  "Non-Reporting Financial Institution under CRS - Pension Fund of a Governmental Entity, International Organization, or Central Bank",
  "Non-Reporting Financial Institution under CRS - Qualified Credit Card Issuer",
  "Non-Reporting Financial Institution under CRS - Trust whose trustee reports all required information with respect to all CRS Reportable Accounts",
  "Other Active NFE",
  "Other Financial Institution, including a Depository Financial Institution, Custodial Institution or Specified Insurance Company",
  "Other Investment Entity",
  "Passive NFE",
  "Passive Non-Financial Entity",
  "Reporting Financial Institution under CRS",
  "Start-up NFE",
  "Treasury Center NFE that is a member of a nonfinancial group",
  "Active Non-Financial Entity - a Government Entity or Central Bank",
  "Active Non-Financial Entity - an International Organization",
  "An Investment Entity located in a Non Participating Jurisdiction and managed by another Financial Institution - a pension fund established as a trust",
  "An Investment Entity located in a Non Participating Jurisdiction and managed by another Financial Institution - a widely-held, regulated Collective Investment Vehicle (CIV) established as a trust",
];
const addressTypeOptions = [
  "P.O. Box",
  "Current Home Address",
  "Current Mailing Address",
  "Care of/Hold Mail Address",
  "Rural Route Number",
  "Office",
];
const allocationMethodologyOptions = [
  "Allocation %",
  "Capital Committed",
  "Capital Committed and Cap Carry Allocation",
];
const companyRegistrationNumberTypeOptions = [
  "IIN for the reporting of an individual identification number",
  "LEI for the reporting of a legal entity identifier",
  "EIN for the reporting of an entity identification number",
  "BRN for the reporting of a business registration number",
  "Other",
];
const capacityOptions = [
  "Attorney in Fact",
  "Beneficial Owner/Self",
  "Bursar",
  "CEO",
  "CFO",
  "Custodian",
  "Director",
  "Executive Vice-President",
  "Executor",
  "Executrix",
  "Guardian",
  "Managing Director",
  "Managing Member",
  "Managing Partner",
  "Member",
  "Parent",
  "Partner",
  "Power of Attorney",
  "President",
  "Provost",
  "Secretary of the Company",
  "Senior Partner",
  "Senior Vice-President",
  "Tax Matters Partner",
  "Treasurer",
  "Trustee",
  "Unknown",
  "Other",
];
const templateCountryOptions = [
  ...countries,
  "Antigua and Barbuda",
  "Burma",
  "Cook Islands",
  "Libyan Arab Jamahiriya",
  "Moldova, Republic Of",
  "Palmyra Atoll",
  "Virgin Islands (British)",
];
const normalizeDropdownValue = (value) =>
  String(value ?? "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

// Dropdown values used by the validation table. These stay in React so the
// table remains usable when the persisted validation payload has no list data.
const reactTemplateDropdownOptions = {
  "Taxpayer Type": taxpayerTypeOptions,
  TaxPayerTypeListItmes: taxpayerTypeOptions,
  "TaxPayer ID Type": taxpayerTypeOptions,
  "Entity type": entityTypeOptions,
  "Entity Type": entityTypeOptions,
  "Entity Classification": entityClassificationOptions,
  "Chapter 4 Status": chapter4StatusOptions,
  Chapter4Status: chapter4StatusOptions,
  "Form Types": formsTypeList,
  "Form type and revision": formsTypeList,
  "Income Code": incomeCodesDropDownList,
  "Income codes": incomeCodesComparisonOptions,
  "Recipient Code": recipientCodeOptions,
  RecipientCodes: recipientCodeOptions,
  "Risk Status": riskStatusOptions,
  "Form Status": formStatusOptions,
  "1099 Income Type": incomeType1099Options,
  "Income Type Default": incomeTypeDefaultOptions,
  DocumentaryEvidenceType: documentaryEvidenceTypeOptions,
  BalanceEntitytypes: balanceEntityTypeOptions,
  FatcaReportingBalance: fatcaReportingBalanceOptions,
  "Exemption Code": exemptionCodeOptions,
  State: [...statesList, "Arkansa (AR)"],
  Country: templateCountryOptions,
  Capacity: capacityOptions,
  "Signatory Capacity": capacityOptions,
  LegalStatus: legalStatusOptions,
  "Legal Status": legalStatusOptions,
  EntityActivationStatus: entityActivationStatusOptions,
  Status: entityActivationStatusOptions,
  AddressType: addressTypeOptions,
  "Address Type": addressTypeOptions,
  "Mail Address Type": addressTypeOptions,
  HybridStatus: hybridStatusOptions,
  UKCDOTStatus: ukCDOTStatusOptions,
  "UK CDOT Status": ukCDOTStatusOptions,
  "CRS Statuses": crsStatusOptions,
  "CRS Status": crsStatusOptions,
  Trinary: trinaryOptions,
  Boolean: booleanOptions,
  IsUSPerson: trinaryOptions,
  IsUSGreenCardHolder: trinaryOptions,
  IsDualCitizenshipHolder: trinaryOptions,
  DoesDualCitizenshipIncludeUnitedStates: trinaryOptions,
  IsBornOrganisedInUS: trinaryOptions,
  HasRenouncedCitizenship: trinaryOptions,
  InUSA31DaysCurrentYear: trinaryOptions,
  IsCheckPerformed: booleanOptions,
  IsSuccessful: booleanOptions,
  "Is US Person Classification": booleanOptions,
  "Signed Certification Confirmation": booleanOptions,
  "VAT Check Performed": booleanOptions,
  "VAT Check Is Successful": booleanOptions,
  "DAC7 Reporting Required": booleanOptions,
  "1042s payment received": booleanOptions,
  CompanyRegistrationNumberOrEINIssuedBy: templateCountryOptions,
  GVSJurisdiction: templateCountryOptions,
  USTINClassificationForEIN: usTinClassificationOptions,
  USTINClassificationForSSN: usTinClassificationOptions,
  "Company registration number or an Entity Identification Number (EIN) Type":
    companyRegistrationNumberTypeOptions,
  AllocationMethodology: allocationMethodologyOptions,
  "Allocation Methodology": allocationMethodologyOptions,
  Allocation: allocationMethodologyOptions,
  "Property type": propertyTypeOptions,
  Propertytype: propertyTypeOptions,
  "Entity Types 2 For EXP": entityTypesForExpOptions,
  "Remittance State_Province": statesList,
};

const formatFieldNameForDisplay = (fieldName) => {
  if (!fieldName) return "";
  // Split on underscores/hyphens, then insert space before each uppercase letter
  // that follows a lowercase letter or digit (camelCase / PascalCase splitting)
  const formattedFieldName = fieldName
    .replace(/[_-]/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());

  return formattedFieldName
    .replace(/\bW\s*9\b/gi, "W-9")
    .replace(/\bW\s*8\s*BEN\s*E\b/gi, "W-8BEN-E")
    .replace(/\bW\s*8\s*BENE\b/gi, "W-8BEN-E")
    .replace(/\bW\s*8\s*BEN\b/gi, "W-8BEN")
    .replace(/\bW\s*8\s*IMY\b/gi, "W-8IMY")
    .replace(/\bW\s*8\s*ECI\b/gi, "W-8ECI")
    .replace(/\bW\s*8\s*EXP\b/gi, "W-8EXP")
    .replace(/\bGIIN\b/gi, "GIIN")
    .replace(/\bEIN\b/gi, "EIN")
    .replace(/\bTIN\b/gi, "TIN")
    .replace(/\bUS\b/gi, "US");
};

/**
 * A dropdown cell that only commits a new value on explicit selection:
 * mouse click on an option, or Enter key while an option is highlighted.
 * Pressing Escape or clicking outside reverts to the original value.
 */
function EditableDropdown({ value, options, onCommit, textStyle }) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [dropdownStyle, setDropdownStyle] = useState({});
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);
  const listRef = useRef(null);

  const filtered = options.filter((opt) =>
    String(opt).toLowerCase().includes(searchText.toLowerCase())
  );

  // Position the dropdown below the cell using getBoundingClientRect
  const openDropdown = () => {
    if (wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setDropdownStyle({
        position: "fixed",
        top: rect.bottom + 2,
        left: rect.left,
        minWidth: Math.max(rect.width, 220),
        zIndex: 99999,
        background: "white",
        border: "1px solid #ccc",
        borderRadius: 4,
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        maxHeight: 240,
        overflowY: "auto",
        width: "max-content",
      });
    }
    setSearchText("");
    setHighlightedIndex(-1);
    setIsOpen(true);
    // Focus the input so keyboard works immediately
    requestAnimationFrame(() => inputRef.current?.focus());
  };

  const closeAndRevert = () => {
    setIsOpen(false);
    setSearchText("");
    setHighlightedIndex(-1);
  };

  const commit = (option) => {
    onCommit(option);
    setIsOpen(false);
    setSearchText("");
    setHighlightedIndex(-1);
  };

  // Close on outside click — revert without saving
  useEffect(() => {
    if (!isOpen) return;
    const handleOutside = (e) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target) &&
        listRef.current &&
        !listRef.current.contains(e.target)
      ) {
        closeAndRevert();
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, [isOpen]);

  // Scroll active item into view when highlightedIndex changes
  useEffect(() => {
    if (listRef.current && highlightedIndex >= 0) {
      const item = listRef.current.children[highlightedIndex];
      if (item) item.scrollIntoView({ block: "nearest" });
    }
  }, [highlightedIndex]);

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((i) => Math.min(i + 1, filtered.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((i) => Math.max(i - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightedIndex >= 0 && highlightedIndex < filtered.length) {
        commit(filtered[highlightedIndex]);
      }
      // Nothing highlighted → do nothing, keep original value
    } else if (e.key === "Escape") {
      e.preventDefault();
      closeAndRevert();
    }
  };

  return (
    <>
      {/* Display area — clicking anywhere opens the dropdown */}
      <div
        ref={wrapperRef}
        onClick={(e) => {
          e.stopPropagation();
          if (!isOpen) openDropdown();
        }}
        style={{
          width: "100%",
          height: "100%",
          cursor: "pointer",
          overflow: "hidden",
          alignSelf: "stretch",
          display: "flex",
          alignItems: "center",
        }}
      >
        {isOpen ? (
          <input
            ref={inputRef}
            value={searchText}
            placeholder={value || ""}
            onChange={(e) => {
              setSearchText(e.target.value);
              setHighlightedIndex(-1);
            }}
            onKeyDown={handleKeyDown}
            style={{
              ...textStyle,
              width: "100%",
              border: "none",
              background: "transparent",
              outline: "none",
              padding: 0,
              font: "inherit",
              cursor: "text",
            }}
          />
        ) : (
          <span
            style={{
              ...textStyle,
              display: "block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={value}
          >
            {value}
          </span>
        )}
      </div>

      {/* Dropdown list rendered into document.body via portal — escapes all stacking contexts */}
      {isOpen &&
        ReactDOM.createPortal(
          <div ref={listRef} style={dropdownStyle}>
            {filtered.length === 0 ? (
              <div style={{ padding: "6px 10px", color: "#999", fontSize: 13 }}>
                No options found
              </div>
            ) : (
              filtered.map((opt, i) => (
                <div
                  key={opt}
                  onMouseDown={(e) => {
                    e.preventDefault();
                    commit(opt);
                  }}
                  onMouseEnter={() => setHighlightedIndex(i)}
                  style={{
                    padding: "5px 10px",
                    cursor: "pointer",
                    fontSize: 13,
                    background: i === highlightedIndex ? "#e8f0fe" : "white",
                    color: "black",
                    whiteSpace: "nowrap",
                  }}
                >
                  {opt}
                </div>
              ))
            )}
          </div>,
          document.body
        )}
    </>
  );
}

export default function DataValidationPopup({
  open,
  onClose,
  rows,
  selectedCheckbox,
  runValidation,
  setOnClickValue,
  selectSheet,
  handleSelectSheetProcess,
  extractedValidatedata,
  formTypesWithCount = [],
  formTypeIndices = {},
  selectedIndex,
  setSelectedIndex,
  viewMode,
  setViewMode,
  handleSaveChanges,
  handleFileUpload,
  handleExcelAuditReport,
  handleDeleteRow,
  handleAddEmptyRow,
  handleAddMatchingRow,
  handleDropdownChange,
  matchedEntitiesData,
  shouldHighlightRow,
  handleSelectedSheet,
  rowHasErrors,
  columnHasErrors,
  getIdDocumentType,
  getFormTypeDisplayName,
  halfWidth,
  isFormTypeWithToggle,
  getForm,
  setIsModalOpen,
  setColumnName,
  setEditValue,
  setOldValue,
  setRowIndex,
  handleSaveEditData,
  onAddNote,
  actionColumnWidth = 52,
  isLoading = false,
}) {
  const { isMenuOpen } = useSharedValue();
  const dvFormContainerRef = useRef(null);
  const [isDVSavingForm, setIsDVSavingForm] = useState(false);
  const [showOnlyErrors, setShowOnlyErrors] = useState(false);
  const [showOnlyErrorColumns, setShowOnlyErrorColumns] = useState(false);

  // Auto-uncheck the error filters once every error is fixed, so the full data
  // reappears immediately instead of leaving the table filtered down to nothing.
  useEffect(() => {
    if (showOnlyErrors && !extractedValidatedata.some((row, i) => rowHasErrors(row, i))) {
      setShowOnlyErrors(false);
    }
  }, [extractedValidatedata, showOnlyErrors, rowHasErrors]);

  useEffect(() => {
    if (
      showOnlyErrorColumns &&
      !handleSelectedSheet().some((column) => columnHasErrors(column.field))
    ) {
      setShowOnlyErrorColumns(false);
    }
  }, [extractedValidatedata, showOnlyErrorColumns, columnHasErrors, handleSelectedSheet]);

  const [isHovered, setIsHovered] = useState(false);
  const [hoverValue, sethoverValue] = useState(false);
  const [hoverIndexValue, setHoverIndexValue] = useState(null);
  const [showLegend, setShowLegend] = useState(false);
  const [hideNonMandatoryColumns, setHideNonMandatoryColumns] = useState(false);

  const mandatoryColumnFields = new Set([
    "UniqueIdentifier",
    "Entity Type",
    "FirstName",
    "LastName",
    "Business Name",
    "BusinessUnit",
  ]);
  const selectedFileRow = rows.find((item) => item.fileImportId === selectedCheckbox);
  const selectedFileName = selectedFileRow?.fileName || "";

  if (!open) return null;

  return (
    <>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 99999,
            backgroundColor: "rgba(255, 255, 255, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader />
        </div>
      )}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          minHeight: 0,
          padding: 10,
          "--action-col-width": `${actionColumnWidth}px`,
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            flexDirection: "row",
            alignItems: "center",
            marginLeft: 10,
            marginTop: 10,
          }}
        >
          <img
            src={backArrowIcon}
            alt="Back"
            title="Return"
            onClick={onClose}
            className="back-arrow-icon"
            style={{
              width: 22,
              height: 22,
              marginRight: 10,
              flexShrink: 0,
            }}
          />
          <div
            style={{
              color: "#3B3B3B",
              fontFamily: fontFamily,
              fontWeight: 500,
              marginRight: 15,
              margin: 0,
              marginRight: 15,
              lineHeight: 1,
            }}
          >
            Data Validation Check :&nbsp;
          </div>
          <div
            style={{
              color: "#3B3B3B",
              fontWeight: 300,

              fontFamily: fontFamily,
              marginRight: "auto",

              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {rows.find((item) => item.fileImportId === selectedCheckbox)?.fileName || ""}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginRight: 10,
              minHeight: 28,
            }}
          >
            {selectedCheckbox !== null && (
              <DownloadExcelFile
                fileName={rows.find((item) => item.fileImportId === selectedCheckbox)?.fileImportId}
                businessunit={
                  rows.find((item) => item.fileImportId === selectedCheckbox)?.businessUnit
                }
                userId={rows.find((item) => item.fileImportId === selectedCheckbox)?.userID}
                organizationId={
                  rows.find((item) => item.fileImportId === selectedCheckbox)?.organizationId
                }
              />
            )}
            {selectedCheckbox !== null && selectedFileRow && (
              <DownloadOriginalFile
                fileImportId={selectedCheckbox}
                fileName={selectedFileName}
                userId={selectedFileRow.userID}
                organizationId={selectedFileRow.organizationId}
                businessunit={selectedFileRow.businessUnit}
              />
            )}
            {selectSheet === "Audit" && (
              <ExcelIcon onclick={handleExcelAuditReport} title="Download Audit Report" audit />
            )}
          </div>

          <div>
            <input
              type="file"
              id="file-upload"
              accept=".xltx,.xlsx"
              style={{ display: "none" }}
              onChange={handleFileUpload}
            />
            <Button
              variant="contained"
              className="review-btn-outline"
              onClick={() => document.getElementById("file-upload").click()}
            >
              Import
            </Button>
          </div>
          <Button
            variant="contained"
            className="review-btn-filled"
            onClick={() => {
              handleSaveChanges(
                rows.find((item) => item.fileImportId === selectedCheckbox).fileImportId,
                rows.find((item) => item.fileImportId === selectedCheckbox).fileImportId
              );
            }}
          >
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>Save & Return</span>
          </Button>
        </div>

        {runValidation === true && (
          <div
            onClick={() => {
              setOnClickValue(false);
            }}
            style={{
              marginTop: "6px",
              display: "flex",
              overflow: "auto",
              flexDirection: "column",
              margin: 10,
            }}
          >
            {/* Sheet Tab Bar */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflowX: selectSheet === "View Forms" ? "hidden" : "auto",
                scrollbarWidth: "thin",
                "-ms-overflow-style": "scrollbar",
                alignItems: "start",
                overflowY: "hidden",
                padding: "5px 0px 10px 0px",
                justifyContent: "start",
                width: "100%",
              }}
            >
              <div className="dv-tab-bar">
                {(() => {
                  const currentRow = rows.find((item) => item.fileImportId === selectedCheckbox);
                  const currentUploadType = currentRow?.uploadType;
                  const hasSelfcertTab =
                    currentUploadType === 13 && currentRow?.dataValidation
                      ? (() => {
                          try {
                            return JSON.parse(currentRow.dataValidation)?.hasSelfcertTab;
                          } catch {
                            return false;
                          }
                        })()
                      : false;

                  const visibleSheetNames = hasSelfcertTab
                    ? [
                        ...allSheetNames.filter(
                          (n) => n !== "Forms" && n !== "Audit" && n !== "View Forms"
                        ),
                        "Forms",
                        "Forms (Self-Cert)",
                        "Audit",
                        "View Forms",
                      ]
                    : allSheetNames;

                  return visibleSheetNames.map((column, index) => {
                    const currentUploadType = rows.find(
                      (item) => item.fileImportId === selectedCheckbox
                    )?.uploadType;

                    let clickableItems = [
                      "Business Entities",
                      "Accounts",
                      "Account Connections",
                      "Audit",
                    ];

                    if (currentUploadType === 13) {
                      const currentRow = rows.find(
                        (item) => item.fileImportId === selectedCheckbox
                      );
                      const hasSelfcertTab = currentRow?.dataValidation
                        ? (() => {
                            try {
                              return JSON.parse(currentRow.dataValidation)?.hasSelfcertTab;
                            } catch {
                              return false;
                            }
                          })()
                        : false;

                      clickableItems = [
                        "Business Entities",
                        "Accounts",
                        "Income Codes",
                        "Account Connections",
                        "Forms",
                        ...(hasSelfcertTab ? ["Forms (Self-Cert)"] : []),
                        "Audit",
                      ];
                    }

                    const isViewFormsEnabled = currentUploadType === 11;

                    if (currentUploadType === 13 && column === "Account Balances") {
                      return null;
                    }

                    const isClickable =
                      clickableItems.includes(column) ||
                      (column === "View Forms" && isViewFormsEnabled);

                    return (
                      <div
                        key={column}
                        onClick={() => {
                          if (isClickable) {
                            handleSelectSheetProcess(column);
                          }
                        }}
                        className={`dv-tab ${
                          selectSheet === column && isClickable
                            ? "dv-tab--active"
                            : isClickable
                              ? "dv-tab--clickable"
                              : "dv-tab--disabled"
                        }`}
                        style={{
                          fontFamily: fontFamily,
                        }}
                      >
                        {column}
                      </div>
                    );
                  });
                })()}
              </div>
            </div>

            {/* Content Area */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "calc(100vh - 230px)",
                overflow: "auto",
                overflowX: "auto",
                alignItems: "start",
                padding: "0px 0px 10px 0px",
                justifyContent: "start",
                scrollbarWidth: "thin",
                "-ms-overflow-style": "scrollbar",
              }}
            >
              {selectSheet === "View Forms" ? (
                <>
                  {/* Form Type Tabs */}
                  <div
                    style={{
                      display: "flex",
                      padding: "10px",
                      fontWeight: "500",
                      fontSize: 14,
                      fontFamily: fontFamily,
                      justifyContent: "space-between",
                    }}
                  >
                    {formTypesWithCount.map(([formType, count]) => {
                      const needsDropdown = count > 1;
                      return (
                        <div
                          key={formType}
                          className={`vf-form-btn ${formTypeIndices[formType].includes(selectedIndex) ? "vf-form-btn--active" : "vf-form-btn--inactive"}`}
                          style={{ marginRight: "10px" }}
                        >
                          {needsDropdown ? (
                            <>
                              <select
                                style={{
                                  appearance: "none",
                                  padding: "5px 10px",
                                  backgroundColor: "transparent",
                                  color: "black",
                                  border: "none",
                                  fontWeight: "bold",
                                  fontSize: 14,
                                  fontFamily: fontFamily,
                                  width: "100%",
                                  cursor: "pointer",
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  opacity: 0,
                                }}
                                value={
                                  formTypeIndices[formType].includes(selectedIndex)
                                    ? selectedIndex
                                    : ""
                                }
                                onChange={(e) => setSelectedIndex(parseInt(e.target.value))}
                              >
                                {formTypeIndices[formType].map((originalIndex) => {
                                  const formData = extractedValidatedata[originalIndex];
                                  let displayValue;

                                  if (formData.documentType) {
                                    if (formData.documentType.includes("idDocument")) {
                                      const idType = getIdDocumentType(formData);
                                      let personName = "";

                                      if (formData.FirstName && formData.LastName) {
                                        personName = `${formData.FirstName} ${formData.LastName}`;
                                      } else if (formData.LastName) {
                                        personName = formData.LastName;
                                      } else if (formData.FirstName) {
                                        personName = formData.FirstName;
                                      } else {
                                        personName = `ID ${originalIndex + 1}`;
                                      }

                                      displayValue = personName;
                                    }
                                  } else {
                                    displayValue =
                                      formData["Beneficial Owner name"] ||
                                      formData["Name of organization"] ||
                                      formData["W8-BENE-Organization_name"] ||
                                      formData["SC-Individual-First_name"] +
                                        " " +
                                        formData["SC-Individual-Last_name"] ||
                                      `#${originalIndex + 1}`;
                                  }

                                  return (
                                    <option key={originalIndex} value={originalIndex}>
                                      {displayValue}
                                    </option>
                                  );
                                })}
                              </select>

                              <div
                                onClick={() => {
                                  setSelectedIndex(formTypeIndices[formType][0]);
                                  if (
                                    getFormTypeDisplayName(formType)
                                      .toLowerCase()
                                      .includes("id document")
                                  ) {
                                    setViewMode("keyValue");
                                  }
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  position: "relative",
                                }}
                              >
                                {getFormTypeDisplayName(formType)}

                                {/* Count Badge on Top Right */}
                                <div className="vf-form-btn-count">{count}</div>
                              </div>
                              <span
                                style={{
                                  marginLeft: "5px",
                                  marginBottom: "5px",
                                }}
                              >
                                ⌵
                              </span>
                            </>
                          ) : (
                            <div
                              onClick={() => {
                                setSelectedIndex(formTypeIndices[formType][0]);
                                if (
                                  getFormTypeDisplayName(formType)
                                    .toLowerCase()
                                    .includes("id document")
                                ) {
                                  setViewMode("keyValue");
                                }
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {getFormTypeDisplayName(formType)}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {/* Display Selected Row Data */}
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      width: "100%",
                      marginTop: "10px",
                      overflow: "hidden",
                      height: "calc(100% - 50px)",
                    }}
                  >
                    {/* Left Half - Form Data */}
                    <div
                      style={{
                        width: halfWidth,
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        overflow: "hidden",
                      }}
                    >
                      {selectedIndex !== null && (
                        <>
                          {/* Toggle View Hyperlink */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              marginBottom: "10px",
                              padding: "0 10px",
                            }}
                          >
                            {isFormTypeWithToggle(
                              extractedValidatedata[selectedIndex]?.formType
                            ) && (
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setViewMode((prevMode) =>
                                    prevMode === "form" ? "keyValue" : "form"
                                  );
                                }}
                                className="vf-toggle-link"
                              >
                                {viewMode === "form" ? "Show Details" : "Edit Form"}
                              </a>
                            )}
                          </div>

                          {/* Scrollable Container for Form Data */}
                          <div
                            ref={viewMode === "form" ? dvFormContainerRef : null}
                            className={viewMode === "form" ? "hide-internal-submit" : ""}
                            style={{
                              overflowY: "auto",
                              overflowX: "hidden",
                              height:
                                viewMode === "form" ? "calc(100% - 80px)" : "calc(100% - 30px)",
                              paddingRight: "10px",
                              width: "100%",
                              maxWidth: "100%",
                            }}
                          >
                            {viewMode === "keyValue" ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  // gap: "8px",
                                  padding: "10px",
                                }}
                              >
                                {(() => {
                                  const fieldOrder = getFormFieldOrder(
                                    extractedValidatedata[selectedIndex]?.formType || ""
                                  );

                                  const currentForm = extractedValidatedata[selectedIndex];
                                  const isW9 =
                                    currentForm?.formType?.toUpperCase().includes("W9") ||
                                    currentForm?.formType?.toUpperCase().includes("W-9");
                                  const hasFirstLastName =
                                    isW9 &&
                                    (currentForm?.["First name and middle name"] ||
                                      currentForm?.["FirstName"]) &&
                                    (currentForm?.["Last name"] || currentForm?.["LastName"]);

                                  const filteredEntries = Object.entries(
                                    extractedValidatedata[selectedIndex]
                                  )
                                    .filter(
                                      ([key]) =>
                                        key !== "matchingRow" &&
                                        key !== "formType" &&
                                        key !== "FormType" &&
                                        key !== "Form Type" &&
                                        key !== "viewPdf" &&
                                        key !== "Form number" &&
                                        key !== "Form_number" &&
                                        key !== "Entity Type" &&
                                        key !== "Chapter4Status" &&
                                        key !== "originalIndexValue" &&
                                        key !== "tables" &&
                                        key !== "incomeItems" &&
                                        key !== "isMapDone" &&
                                        key !== "treatyClaims" &&
                                        // For W-9: hide "Name of organization" when first/last name are present
                                        !(hasFirstLastName && key === "Name of organization")
                                    )
                                    .filter(
                                      ([key, value]) =>
                                        value !== null &&
                                        value !== undefined &&
                                        value !== "" &&
                                        value !== false &&
                                        value !== "N/A"
                                    );

                                  const sortedEntries = sortByFieldOrder(
                                    filteredEntries,
                                    fieldOrder
                                  );

                                  return (
                                    <>
                                      {sortedEntries.map(([key, value], idx) => (
                                        <div
                                          key={idx}
                                          style={{
                                            fontSize: 14,
                                            fontFamily: fontFamily,
                                            fontWeight: 400,

                                            padding: "12px 0px",
                                            borderBottom: "0.5px solid #EEEDED",
                                            color: "#3B3B3B",
                                          }}
                                        >
                                          <strong
                                            style={{
                                              fontWeight: 400,
                                              color: "#3B3B3B",
                                              fontSize: 14,
                                            }}
                                          >
                                            {key === "Name of organization" &&
                                            currentForm?.[
                                              "W9-Tax_classification_individual_sole_proprietor"
                                            ] === "selected"
                                              ? "Beneficial Owner"
                                              : formatFieldNameForDisplay(key)}
                                          </strong>
                                          &nbsp;:{" "}
                                          <span
                                            style={{
                                              color: "var(--application-primary-color)",
                                              fontSize: 14,
                                              fontWeight: 400,
                                            }}
                                          >
                                            {value === true ? "selected" : value}
                                          </span>
                                        </div>
                                      ))}
                                      <FormTablesDisplay
                                        data={extractedValidatedata[selectedIndex]}
                                        fontFamily={fontFamily}
                                      />
                                    </>
                                  );
                                })()}
                              </div>
                            ) : (
                              <>
                                {getForm(
                                  extractedValidatedata[selectedIndex]?.formType,
                                  extractedValidatedata[selectedIndex],
                                  selectedIndex
                                )}
                              </>
                            )}
                          </div>
                          {/* Save Form button – only in Edit Form mode, pinned below the scrollable area */}
                          {viewMode === "form" && (
                            <div
                              style={{
                                flexShrink: 0,
                                paddingTop: "10px",
                                paddingBottom: "10px",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <button
                                disabled={isDVSavingForm}
                                onClick={() => {
                                  const submitBtn =
                                    dvFormContainerRef.current?.querySelector('[type="submit"]');
                                  if (submitBtn) {
                                    setIsDVSavingForm(true);
                                    submitBtn.click();
                                    setTimeout(() => setIsDVSavingForm(false), 2500);
                                  }
                                }}
                                style={{
                                  backgroundColor: "var(--btn-primary-bg)",
                                  color: "var(--btn-primary-text)",
                                  border: "none",
                                  borderRadius: "4px",
                                  padding: "6px 20px",
                                  cursor: isDVSavingForm ? "not-allowed" : "pointer",
                                  fontFamily: fontFamily,
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  opacity: isDVSavingForm ? 0.8 : 1,
                                }}
                              >
                                {isDVSavingForm ? (
                                  <>
                                    <CircularProgress size={13} style={{ color: "white" }} />
                                    Saving...
                                  </>
                                ) : (
                                  <>
                                    Save Form
                                    <img
                                      src={rightArrowIcon}
                                      alt=""
                                      style={{ width: "12px", height: "12px" }}
                                    />
                                  </>
                                )}
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </div>

                    {/* Right Half - Selected Row PDF */}
                    <div
                      style={{
                        width: halfWidth,
                        display: "flex",
                        flexDirection: "column",
                        borderLeft: "1px solid #ddd",
                        paddingLeft: "10px",
                        height: "100%",
                        overflow: "hidden",
                      }}
                    >
                      {selectedIndex !== null && extractedValidatedata[selectedIndex]?.viewPdf && (
                        <div style={{ height: "100%", overflow: "hidden" }}>
                          <SecureDocumentViewer
                            organizationId={
                              rows.find((row) => row.fileImportId === selectedCheckbox)
                                ?.organizationId
                            }
                            userId={
                              rows.find((row) => row.fileImportId === selectedCheckbox)?.userID
                            }
                            fileImportId={selectedCheckbox}
                            fileName={extractedValidatedata[selectedIndex]?.viewPdf
                              ?.split("/")
                              .pop()}
                            style={{ height: "100%", width: "100%" }}
                            fileType="split_documents"
                            businessunit={
                              rows.find((row) => row.fileImportId === selectedCheckbox)
                                ?.businessUnit || ""
                            }
                            useFastLoad
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                // Original rendering for other sheets
                <>
                  {/* Error Filter Checkboxes */}
                  {selectSheet !== "Audit" &&
                    extractedValidatedata.some((row, i) => rowHasErrors(row, i)) && (
                      <div
                        style={{
                          padding: "10px",
                          backgroundColor: "#f5f5f5",
                          borderBottom: "1px solid #e0e0e0",
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                          position: "sticky",
                          top: 0,
                          left: 0,
                          zIndex: 9,
                        }}
                      >
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            fontFamily: fontFamily,
                            fontSize: "13px",
                            fontWeight: 400,
                            color: "#333",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={showOnlyErrors}
                            onChange={(e) => setShowOnlyErrors(e.target.checked)}
                            style={{
                              marginRight: "8px",
                            }}
                          />
                          Show Only Rows with Errors
                        </label>
                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            fontFamily: fontFamily,
                            fontSize: "13px",
                            fontWeight: 400,
                            color: "#333",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={showOnlyErrorColumns}
                            onChange={(e) => setShowOnlyErrorColumns(e.target.checked)}
                            style={{
                              marginRight: "8px",
                            }}
                          />
                          Show Only Columns with Errors
                        </label>
                      </div>
                    )}{" "}
                  {/* Table — single shared-width container so header and rows use identical flex basis */}
                  <div style={{ width: "100%", minWidth: "max-content" }}>
                    {/* Table Header */}
                    <div className="dv-table-header">
                      {selectSheet !== "Audit" && <div className="dv-table-action-spacer" />}
                      {handleSelectedSheet()
                        .filter((column) => {
                          if (showOnlyErrorColumns) {
                            return columnHasErrors(column.field);
                          }
                          if (hideNonMandatoryColumns) {
                            return (
                              mandatoryColumnFields.has(column.field) ||
                              extractedValidatedata.some(
                                (row) =>
                                  row[column.field] !== null &&
                                  row[column.field] !== undefined &&
                                  row[column.field] !== ""
                              )
                            );
                          }
                          return true;
                        })
                        .map((column, colIndex) => (
                          <div
                            key={column.field}
                            title={column.field}
                            className={`dv-table-header-cell${colIndex === 0 ? " dv-table-header-cell--sticky" : ""}`}
                            style={{ fontFamily: fontFamily }}
                          >
                            {column.header}
                          </div>
                        ))}
                    </div>
                    {/* Table Rows */}
                    {extractedValidatedata
                      .map((row, originalIndex) => ({ row, originalIndex }))
                      .filter(({ row, originalIndex }) => {
                        if (showOnlyErrors) {
                          return rowHasErrors(row, originalIndex);
                        }
                        return true;
                      })
                      .map(({ row, originalIndex: index }) => (
                        <React.Fragment key={`row-fragment-${index}`}>
                          {selectSheet === "Audit" ? (
                            <div className="dv-table-row dv-table-row--audit">
                              {handleSelectedSheet()
                                .filter((column) => {
                                  if (showOnlyErrorColumns) {
                                    return columnHasErrors(column.field);
                                  }
                                  if (hideNonMandatoryColumns) {
                                    return (
                                      mandatoryColumnFields.has(column.field) ||
                                      extractedValidatedata.some(
                                        (row) =>
                                          row[column.field] !== null &&
                                          row[column.field] !== undefined &&
                                          row[column.field] !== ""
                                      )
                                    );
                                  }
                                  return true;
                                })
                                .map((column, colIndex) => (
                                  <div
                                    key={column.field}
                                    title={row[column.field]}
                                    className={`dv-table-row-cell${colIndex === 0 ? " dv-table-row-cell--sticky" : ""}`}
                                    style={{ fontFamily: fontFamily }}
                                  >
                                    {column.field === "modifiedDate"
                                      ? formatDate(row[column.field])
                                      : row[column.field]}
                                  </div>
                                ))}
                            </div>
                          ) : (
                            <div className="dv-table-row">
                              {/* Actions column */}
                              {selectSheet !== "Audit" && (
                                <div className="dv-table-action-col">
                                  <button
                                    title="Delete row"
                                    onClick={() => handleDeleteRow(index)}
                                    style={{
                                      border: "none",
                                      background: "none",
                                      cursor: "pointer",
                                      padding: "4px",
                                      borderRadius: "4px",
                                      display: "flex",
                                      alignItems: "center",
                                      color: "#d32f2f",
                                    }}
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background = "#fdecea";
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background = "none";
                                    }}
                                  >
                                    <img src={deleteIcon} alt="Delete" />
                                  </button>
                                </div>
                              )}

                              {/* Data cells */}
                              {handleSelectedSheet()
                                .filter((column) => {
                                  if (showOnlyErrorColumns) {
                                    return columnHasErrors(column.field);
                                  }
                                  if (hideNonMandatoryColumns) {
                                    return (
                                      mandatoryColumnFields.has(column.field) ||
                                      extractedValidatedata.some(
                                        (r) =>
                                          r[column.field] !== null &&
                                          r[column.field] !== undefined &&
                                          r[column.field] !== ""
                                      )
                                    );
                                  }
                                  return true;
                                })
                                .map((column, colIndex) => {
                                  let isMandatoryFiled = false;
                                  if (
                                    column.field === "UniqueIdentifier" &&
                                    !row["UniqueIdentifier"]
                                  ) {
                                    isMandatoryFiled = true;
                                  }
                                  if (column.field === "Entity Type" && !row["Entity Type"]) {
                                    isMandatoryFiled = true;
                                  }
                                  if (
                                    row["Entity Type"] === "Individual" ||
                                    row["Entity Type"] === "Individual/Sole Proprietor"
                                  ) {
                                    if (column.field === "FirstName" && !row["FirstName"]) {
                                      isMandatoryFiled = true;
                                    }
                                    if (column.field === "LastName" && !row["LastName"]) {
                                      isMandatoryFiled = true;
                                    }
                                  }
                                  if (row["Entity Type"] === "Corporation") {
                                    if (column.field === "Business Name" && !row["Business Name"]) {
                                      isMandatoryFiled = true;
                                    }
                                  }
                                  if (column.field === "BusinessUnit" && !row["BusinessUnit"]) {
                                    isMandatoryFiled = true;
                                  }
                                  let permCountry = row["Perm. Country"];
                                  let mailCountry = row["Mail Country"];

                                  const templateDropdownOptions =
                                    selectSheet === "Business Entities"
                                      ? {
                                          "Legal Status": legalStatusOptions,
                                          "TaxPayer ID Type": taxpayerTypeOptions,
                                          Status: entityActivationStatusOptions,
                                          "UK CDOT Status": ukCDOTStatusOptions,
                                          "CRS Status": crsStatusOptions,
                                          "Address Type": addressTypeOptions,
                                          "Mail Address Type": addressTypeOptions,
                                          HybridStatus: hybridStatusOptions,
                                          IsUSPerson: trinaryOptions,
                                          IsUSGreenCardHolder: trinaryOptions,
                                          IsDualCitizenshipHolder: trinaryOptions,
                                          DoesDualCitizenshipIncludeUnitedStates: trinaryOptions,
                                          IsBornOrganisedInUS: trinaryOptions,
                                          HasRenouncedCitizenship: trinaryOptions,
                                          InUSA31DaysCurrentYear: trinaryOptions,
                                          IsCheckPerformed: booleanOptions,
                                          IsSuccessful: booleanOptions,
                                          "Is US Person Classification": booleanOptions,
                                          "Signed Certification Confirmation": booleanOptions,
                                          "VAT Check Performed": booleanOptions,
                                          "VAT Check Is Successful": booleanOptions,
                                          "DAC7 Reporting Required": booleanOptions,
                                          "Company registration number or an Entity Identification Number (EIN) Type":
                                            companyRegistrationNumberTypeOptions,
                                        }
                                      : selectSheet === "Accounts"
                                        ? {
                                            "Recipient Code": recipientCodeOptions,
                                            "Risk Status": riskStatusOptions,
                                            IsFlowThroughAccount: booleanOptions,
                                            "Assume Primary WHR": booleanOptions,
                                            "Aggregate WHR 0%": booleanOptions,
                                            "Cheque Payment": booleanOptions,
                                            "Allocation Methodology": allocationMethodologyOptions,
                                            "Signatory Capacity": capacityOptions,
                                          }
                                        : selectSheet === "Account Connections"
                                          ? { Allocation: allocationMethodologyOptions }
                                          : {};

                                  const dropdownOptions = {
                                    ...reactTemplateDropdownOptions,
                                    ...templateDropdownOptions,
                                  };

                                  const isDropdownColumn = [
                                    "Entity Type",
                                    "Entity Classification",
                                    "Chapter4Status",
                                    "FATCA Entity Types",
                                    "Form type and revision",
                                    "CountryOfBirth",
                                    "CountryOfBirthOther",
                                    "Country Of Citizenship For Tax Purposes",
                                    "Country Of Citizenship For Tax Purposes Other",
                                    "Country Of Citizenship For Tax Purposes2",
                                    "Country Of Citizenship For Tax Purposes3",
                                    "Business Country",
                                    "CountryOther",
                                    "Domicile Country",
                                    "ForeignTaxpayerCountry",
                                    "Perm. Country",
                                    "Perm. CountryOther",
                                    "Mail Country",
                                    "Mail CountryOther",
                                    "Contact CellNumber Country",
                                    "Contact Telephone Country",
                                    "Contact Telephone Country2",
                                    "VATCountry",
                                    "Treaty country",
                                    "Foreign Tax Country",
                                    "Self-cert Primary Jurisdiction2",
                                    "Self-cert Additional Jurisdiction1",
                                    "Self-cert Additional Jurisdiction2",
                                    "Permanent Country",
                                    "Permanent Country Other",
                                    "Country of Citizenship",
                                    "Country of incorporation or organization",
                                    "Mailing address Country",
                                    "Mailing address Country Other",
                                    "Disregarded entity address Country",
                                    ...(selectSheet === "Accounts"
                                      ? ["Remittance Country", "Signatory Capacity"]
                                      : []),
                                    ...(selectSheet === "Income Codes" ? ["Income Code"] : []),
                                    ...(permCountry === "United States" || permCountry === "Canada"
                                      ? ["State_Province"]
                                      : []),
                                    ...(mailCountry === "United States" || mailCountry === "Canada"
                                      ? ["State_Province2"]
                                      : []),
                                    ...(selectSheet === "Forms" &&
                                    (row["Permanent Country"] === "United States" ||
                                      row["Permanent Country"] === "Canada")
                                      ? ["Permanent State Province"]
                                      : []),
                                    ...(selectSheet === "Forms" &&
                                    (row["Mailing address Country"] === "United States" ||
                                      row["Mailing address Country"] === "Canada")
                                      ? ["Mailing address State Province"]
                                      : []),
                                    ...Object.keys(dropdownOptions),
                                  ].includes(column.field);

                                  let options = [];
                                  if (column.field === "Entity Type") options = entityTypeOptions;
                                  else if (column.field === "Entity Classification")
                                    options = entityClassificationOptions;
                                  else if (column.field === "Chapter4Status")
                                    options = chapter4StatusOptions;
                                  else if (column.field === "FATCA Entity Types")
                                    options = chapter4StatusOptions;
                                  else if (column.field === "Form type and revision")
                                    options = formsTypeList;
                                  else if (column.field === "Income Code")
                                    options = incomeCodesDropDownList;
                                  else if (
                                    [
                                      "CountryOfBirth",
                                      "CountryOfBirthOther",
                                      "Country Of Citizenship For Tax Purposes",
                                      "Country Of Citizenship For Tax Purposes Other",
                                      "Country Of Citizenship For Tax Purposes2",
                                      "Country Of Citizenship For Tax Purposes3",
                                      "Business Country",
                                      "CountryOther",
                                      "Domicile Country",
                                      "ForeignTaxpayerCountry",
                                      "Perm. Country",
                                      "Perm. CountryOther",
                                      "Mail Country",
                                      "Mail CountryOther",
                                      "Contact CellNumber Country",
                                      "Contact Telephone Country",
                                      "Contact Telephone Country2",
                                      "VATCountry",
                                      "Treaty country",
                                      "Foreign Tax Country",
                                      "Self-cert Primary Jurisdiction2",
                                      "Self-cert Additional Jurisdiction1",
                                      "Self-cert Additional Jurisdiction2",
                                      "Permanent Country",
                                      "Permanent Country Other",
                                      "Country of Citizenship",
                                      "Country of incorporation or organization",
                                      "Mailing address Country",
                                      "Mailing address Country Other",
                                      "Disregarded entity address Country",
                                      "Remittance Country",
                                    ].includes(column.field)
                                  )
                                    options = templateCountryOptions;
                                  else if (column.field === "State_Province")
                                    options = countriesWithStates[permCountry] || [];
                                  else if (column.field === "State_Province2")
                                    options = countriesWithStates[mailCountry] || [];
                                  else if (column.field === "Permanent State Province")
                                    options = countriesWithStates[row["Permanent Country"]] || [];
                                  else if (column.field === "Mailing address State Province")
                                    options =
                                      countriesWithStates[row["Mailing address Country"]] || [];

                                  if (dropdownOptions[column.field]) {
                                    options = dropdownOptions[column.field];
                                  }

                                  let isValueInOptions = false;
                                  if (isDropdownColumn) {
                                    if (
                                      column.field === "State_Province" ||
                                      column.field === "State_Province2" ||
                                      column.field === "Permanent State Province" ||
                                      column.field === "Mailing address State Province"
                                    ) {
                                      const country =
                                        column.field === "State_Province"
                                          ? permCountry
                                          : column.field === "State_Province2"
                                            ? mailCountry
                                            : column.field === "Permanent State Province"
                                              ? row["Permanent Country"]
                                              : row["Mailing address Country"];
                                      isValueInOptions = isValidStateForCountry(
                                        row[column.field],
                                        country
                                      );
                                    } else {
                                      isValueInOptions =
                                        row[column.field] &&
                                        options.some(
                                          (opt) =>
                                            normalizeDropdownValue(opt) ===
                                            normalizeDropdownValue(row[column.field])
                                        );
                                    }
                                  }

                                  const formatValidation = validateField(
                                    column.field,
                                    row[column.field]
                                  );
                                  const hasFormatError =
                                    !formatValidation.isValid &&
                                    row[column.field] &&
                                    String(row[column.field]).trim() !== "";

                                  const matchStatus =
                                    selectSheet === "Business Entities"
                                      ? shouldHighlightRow(row[column.field], index)
                                      : false;

                                  return (
                                    <div
                                      title={
                                        hasFormatError
                                          ? formatValidation.errorMessage
                                          : row[column.field]
                                      }
                                      key={column.field}
                                      onMouseEnter={() => {
                                        setIsHovered(true);
                                        sethoverValue(row[column.field]);
                                        setHoverIndexValue(index);
                                      }}
                                      onMouseLeave={() => {
                                        setIsHovered(false);
                                      }}
                                      onClick={() => {
                                        if (isDropdownColumn) {
                                          setColumnName(column.field);
                                          setEditValue(row[column.field]);
                                          setOldValue(row[column.field]);
                                          setRowIndex(index);
                                          handleSaveEditData();
                                        } else {
                                          if (!isDropdownColumn) {
                                            setIsModalOpen(true);
                                            setColumnName(column.field);
                                            setOldValue(row[column.field]);
                                            setEditValue(row[column.field]);
                                            setRowIndex(index);
                                          }
                                        }
                                      }}
                                      className={`dv-table-row-cell${colIndex === 0 ? " dv-table-row-cell--sticky" : ""}`}
                                      style={{
                                        fontFamily: fontFamily,
                                        backgroundColor:
                                          isMandatoryFiled === true
                                            ? "#f8d7da"
                                            : !["UniqueIdentifier", "BusinessUnit"].includes(
                                                  column.field
                                                )
                                              ? matchStatus.highlight === true &&
                                                matchStatus.matchType === "both"
                                                ? "transparent"
                                                : matchStatus.highlight === true &&
                                                    matchStatus.matchType === "viewForm"
                                                  ? "#FFD580"
                                                  : "transparent"
                                              : "transparent",
                                        height: isMandatoryFiled === true ? 31 : 34,
                                        color:
                                          (isDropdownColumn && !isValueInOptions) || hasFormatError
                                            ? "red"
                                            : "black",
                                        ...(colIndex === 0
                                          ? {
                                              background:
                                                isMandatoryFiled === true
                                                  ? "#f8d7da"
                                                  : !["UniqueIdentifier", "BusinessUnit"].includes(
                                                        column.field
                                                      )
                                                    ? matchStatus.highlight === true &&
                                                      matchStatus.matchType === "both"
                                                      ? "white"
                                                      : matchStatus.highlight === true &&
                                                          matchStatus.matchType === "viewForm"
                                                        ? "#FFD580"
                                                        : "white"
                                                    : "white",
                                            }
                                          : {}),
                                      }}
                                    >
                                      {isDropdownColumn ? (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "stretch",
                                            width: "100%",
                                            height: "100%",
                                            alignSelf: "stretch",
                                            position: "relative",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <EditableDropdown
                                            value={row[column.field]}
                                            options={options}
                                            onCommit={(selectedValue) => {
                                              // const prevValue = row[column.field];
                                              // setColumnName(column.field);
                                              // setEditValue(selectedValue);
                                              // setOldValue(prevValue);
                                              // setRowIndex(index);
                                              handleDropdownChange(
                                                { target: { value: selectedValue } },
                                                row,
                                                column.field,
                                                index
                                              );
                                              // handleSaveEditData();
                                            }}
                                            textStyle={{
                                              width:
                                                matchStatus.matchType === "both"
                                                  ? "calc(100% - 10px)"
                                                  : "100%",
                                              color: isValueInOptions ? "black" : "red",
                                            }}
                                          />
                                          {matchStatus.matchType === "both" && (
                                            <span
                                              style={{
                                                color: "green",
                                                position: "absolute",
                                                right: "2px",
                                                fontSize: "14px",
                                                pointerEvents: "none",
                                              }}
                                            >
                                              ✓
                                            </span>
                                          )}
                                        </div>
                                      ) : row[column.field] !== null && row[column.field] !== "" ? (
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            width: "100%",
                                            position: "relative",
                                          }}
                                        >
                                          <span
                                            style={{
                                              maxWidth:
                                                matchStatus.matchType === "both"
                                                  ? "calc(100% - 10px)"
                                                  : "100%",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                            {row[column.field]}
                                          </span>
                                          {matchStatus.matchType === "both" && (
                                            <span
                                              style={{
                                                color: "green",
                                                marginLeft: "4px",
                                                fontSize: "14px",
                                                flexShrink: 0,
                                              }}
                                            >
                                              ✓
                                            </span>
                                          )}
                                        </div>
                                      ) : (
                                        <button
                                          style={{
                                            border: "none",
                                            background: "none",
                                            cursor: "pointer",
                                          }}
                                        >
                                          {row[column.field]}
                                        </button>
                                      )}
                                    </div>
                                  );
                                })}
                            </div>
                          )}

                          {/* Render matched entities beneath this specific row */}
                          {selectSheet === "Business Entities" &&
                            matchedEntitiesData[index] &&
                            matchedEntitiesData[index].map((matchedEntity, matchIndex) => {
                              const entity = matchedEntity.entity || {};
                              const matchedUniqueId =
                                entity.uniqueIdentifier || matchedEntity.uniqueIdentifier;

                              const isDuplicate = extractedValidatedata.some((existingRow) => {
                                const existingUniqueId =
                                  existingRow["Unique Identifier"] ||
                                  existingRow.uniqueIdentifier ||
                                  existingRow.UniqueIdentifier;
                                return (
                                  existingUniqueId &&
                                  matchedUniqueId &&
                                  existingUniqueId.trim().toLowerCase() ===
                                    matchedUniqueId.trim().toLowerCase()
                                );
                              });

                              if (isDuplicate) {
                                return null;
                              }

                              const displayBusinessName = entity.businessName || "";
                              const firstName = entity.firstName || "";
                              const lastName = entity.lastName || "";

                              return (
                                <div
                                  key={`match-${index}-${matchIndex}`}
                                  className="dv-table-row"
                                  style={getMatchRowStyle(true)}
                                >
                                  <div className="dv-table-action-col--match">
                                    <button
                                      title="Replace with this entity"
                                      onClick={() => handleAddMatchingRow(index, matchIndex)}
                                      style={{
                                        border: "none",
                                        background: "none",
                                        cursor: "pointer",
                                        padding: "4px",
                                        borderRadius: "4px",
                                        display: "flex",
                                        alignItems: "center",
                                        color: "var(--application-primary-color)",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.background = "#e3f6fd";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.background = "none";
                                      }}
                                    >
                                      <img
                                        src={refreshIcon}
                                        alt="Replace"
                                        style={{ filter: "var(--icon-download-filter)" }}
                                      />
                                    </button>
                                  </div>
                                  {handleSelectedSheet()
                                    .filter((column) => {
                                      if (showOnlyErrorColumns) {
                                        return columnHasErrors(column.field);
                                      }
                                      if (hideNonMandatoryColumns) {
                                        return (
                                          mandatoryColumnFields.has(column.field) ||
                                          extractedValidatedata.some(
                                            (r) =>
                                              r[column.field] !== null &&
                                              r[column.field] !== undefined &&
                                              r[column.field] !== ""
                                          )
                                        );
                                      }
                                      return true;
                                    })
                                    .map((column, colIndex) => {
                                      let matchedValue = "";

                                      if (
                                        column.field === "Unique Identifier" ||
                                        column.field === "UniqueIdentifier"
                                      ) {
                                        matchedValue =
                                          entity.uniqueIdentifier ||
                                          matchedEntity.uniqueIdentifier ||
                                          "N/A";
                                      } else if (column.field === "Business Name") {
                                        matchedValue = displayBusinessName;
                                      } else if (
                                        column.field === "FirstName" ||
                                        column.field === "First Name"
                                      ) {
                                        matchedValue = firstName;
                                      } else if (
                                        column.field === "LastName" ||
                                        column.field === "Last Name"
                                      ) {
                                        matchedValue = lastName;
                                      } else if (column.field === "Entity Type") {
                                        matchedValue = entity.type || "N/A";
                                      } else if (column.field === "BusinessUnit") {
                                        matchedValue = entity.businessUnit || "N/A";
                                      } else if (column.field === "Entity Classification") {
                                        matchedValue = entity.entityClassification || "";
                                      } else if (
                                        column.field === "Chapter4Status" ||
                                        column.field === "Chapter 4 Status"
                                      ) {
                                        matchedValue = entity.chapter4Status || "";
                                      } else if (column.field === "Perm. Address Line1") {
                                        matchedValue = entity.permanentAddressLine1 || "";
                                      } else if (column.field === "Perm. Address Line2") {
                                        matchedValue = entity.permanentAddressLine2 || "";
                                      } else if (column.field === "City_Town") {
                                        matchedValue = entity.permanentAddressCity || "";
                                      } else if (column.field === "State_Province") {
                                        matchedValue = entity.permanentAddressState || "";
                                      } else if (column.field === "Perm. Country") {
                                        matchedValue = entity.permanentAddressCountry || "";
                                      } else if (column.field === "Zip_PostalCode") {
                                        matchedValue = entity.permanentAddressPostalCode || "";
                                      } else if (column.field === "Mail Address Line1") {
                                        matchedValue = entity.mailingAddressLine1 || "";
                                      } else if (column.field === "Mail Address Line2") {
                                        matchedValue = entity.mailingAddressLine2 || "";
                                      } else if (column.field === "Mail City_Town") {
                                        matchedValue = entity.mailingAddressCity || "";
                                      } else if (column.field === "State_Province2") {
                                        matchedValue = entity.mailingAddressState || "";
                                      } else if (column.field === "Mail Country") {
                                        matchedValue = entity.mailingAddressCountry || "";
                                      } else if (column.field === "Mail Zip_PostalCode") {
                                        matchedValue = entity.mailingAddressPostalCode || "";
                                      } else if (column.field === "ATIN") {
                                        matchedValue = entity.ATIN || "";
                                      } else if (column.field === "EIN") {
                                        matchedValue = entity.EIN || "";
                                      } else if (
                                        column.field === "SSNOrITIN" ||
                                        column.field === "SSN or ITIN"
                                      ) {
                                        matchedValue = entity.SSNOrITIN || "";
                                      } else if (column.field === "PTIN") {
                                        matchedValue = entity.PTIN || "";
                                      } else if (column.field === "QIEIN") {
                                        matchedValue = entity.QIEIN || "";
                                      } else if (column.field === "WP-EIN") {
                                        matchedValue = entity["WP-EIN"] || "";
                                      } else if (column.field === "WT-EIN") {
                                        matchedValue = entity["WT-EIN"] || "";
                                      } else if (
                                        column.field === "ForeignTaxpayerId" ||
                                        column.field === "Foreign Taxpayer ID"
                                      ) {
                                        matchedValue = entity.ForeignTaxpayerId || "";
                                      } else if (column.field === "GIIN") {
                                        matchedValue = entity.GIIN || "";
                                      } else {
                                        matchedValue =
                                          entity[column.field] ||
                                          matchedEntity.form?.[column.field] ||
                                          "";
                                      }

                                      return (
                                        <div
                                          key={column.field}
                                          title={matchedValue}
                                          className={`dv-table-row-cell${colIndex === 0 ? " dv-table-row-cell--sticky" : ""}`}
                                          style={{
                                            fontFamily: fontFamily,
                                            fontWeight: 500,
                                            borderLeft: "1px solid #e0e0e0",
                                            ...(colIndex === 0
                                              ? {
                                                  background: "#e8f5e9",
                                                }
                                              : {}),
                                          }}
                                        >
                                          {matchedValue}
                                        </div>
                                      );
                                    })}
                                </div>
                              );
                            })}
                        </React.Fragment>
                      ))}
                  </div>
                  {/* end table wrapper */}
                  {selectSheet !== "Audit" && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 8,
                        marginTop: 20,
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        className="review-btn-outline"
                        onClick={handleAddEmptyRow}
                      >
                        Add Row
                      </Button>
                      <Button
                        variant="outlined"
                        className="review-btn-outline"
                        onClick={() => setShowLegend((v) => !v)}
                      >
                        {showLegend ? "Hide Key" : "View Key"}
                      </Button>
                      <Button
                        variant="outlined"
                        className="review-btn-outline"
                        onClick={() => setHideNonMandatoryColumns((v) => !v)}
                      >
                        {hideNonMandatoryColumns
                          ? "Show All Columns"
                          : "Hide Non-Mandatory Columns"}
                      </Button>
                    </div>
                  )}
                </>
              )}
              {selectSheet !== "Audit" && selectSheet !== "View Forms" && showLegend && (
                <DataValidationLegend fontFamily={fontFamily} />
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
